import useSWR from 'swr';

import dashboardMetricsAPI from 'api/dashboardMetricsAPI';

const ENDPOINT = '/api/dashboard-metrics/applicant-volume';

const defaultData = {
  applications_by_month: [],
  candidates_by_month: [],
};

/**
 * Data management wrapper for fetching/caching applicant volume metrics.
 *
 * Usage: const { data, isLoading, error } = useApplicantVolumeMetrics(filters);
 */
export const useApplicantVolumeMetrics = ({
  hiringSeasons,
  years,
  schools = [],
  subcategories = [],
  genders = [],
  ethnicities = [],
}) => {
  // Using ref/memo doesn't work for this library... need to stringify our deps.
  const key = [
    ENDPOINT,
    hiringSeasons.toString(),
    years.toString(),
    schools.toString(),
    subcategories.toString(),
    genders.toString(),
    ethnicities.toString(),
  ];
  const options = { dedupingInterval: 30000, focusThrottleInterval: 30000 };

  const { data, error } = useSWR(
    key,
    () =>
      dashboardMetricsAPI.getApplicantVolumeMetrics({
        hiringSeasons,
        years,
        schools,
        subcategories,
        genders,
        ethnicities,
      }),
    options
  );

  const isLoading = data === undefined;

  return { data: data ?? defaultData, isLoading, error };
};
